import { render, staticRenderFns } from "./RecommendedChild.vue?vue&type=template&id=1593967c&scoped=true&"
import script from "./RecommendedChild.vue?vue&type=script&lang=js&"
export * from "./RecommendedChild.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedChild.vue?vue&type=style&index=0&id=1593967c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1593967c",
  null
  
)

export default component.exports